import React from 'react'
import { Button, Modal } from '@sainsburys-tech/fable'

class ThanksMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: true
    }
  }

	handleClose = () => {
	  this.setState({ isOpen: false })
	}

	render() {
	  const { isOpen } = this.state

	  if (!isOpen) {
	    return null
	  }

	  return (
  <Modal
    header={{
				  label: 'Thank you',
				  isDismissible: true,
    }}
    isOpen={isOpen}
    onClose={this.handleClose}
    hasClickawayClose={false}
    renderFooter={(
      <Button type="button" variant="primary" isFullWidth onClick={this.handleClose}>
        Close
      </Button>
				)}
  >
    <div className="dsib-feedbackThanks__body">
      <div className="dsib-feedbackThanks__title">
        <span aria-label="clapping hands" role="img" className="feedback-emoji">👏</span>
        <div className="dsib-feedbackThanks__titleText">Thank you</div>
      </div>
      <p className="dsib-feedbackThanks__text">
        Thanks for taking the time to send your comments. We rely on hearing from our colleagues to continue to prioritise making improvements in the coming releases.
      </p>
    </div>
  </Modal>
	  )
	}
}

export default ThanksMessage
